import { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Context } from "../../context/UsuarioContext";
import { podeVer, primeiraRotaPermitida } from "../../utils/secoes";
import { CHAVE_TOKEN } from "../../utils/formata";

// Envolve as rotas de seção: só renderiza se o usuário pode ver a seção.
// Sem token → login. Usuário ainda carregando → null (nunca pisca tela proibida).
// Se o usuário não carregar em alguns segundos, a API está fora (ex: banco caiu) —
// mostra um aviso em vez de deixar a tela vazia ("tela azul" de 27/08).
export default function RotaSecao({ chave, children }) {
  const { usuario } = useContext(Context);
  const [demorou, setDemorou] = useState(false);

  useEffect(() => {
    if (usuario?.id) return;
    const t = setTimeout(() => setDemorou(true), 7000);
    return () => clearTimeout(t);
  }, [usuario?.id]);

  if (!localStorage.getItem(CHAVE_TOKEN)) return <Navigate to="/login" replace />;
  if (!usuario?.id) {
    if (!demorou) return null;
    return (
      <div className="pagina">
        <div className="he-card" style={{ maxWidth: 520, margin: "3em auto", textAlign: "center" }}>
          <i className="bi bi-cloud-slash he-dourado" style={{ fontSize: "2.5em" }}></i>
          <h4 className="he-titulo" style={{ marginTop: "0.5em" }}>Servidor indisponível no momento</h4>
          <p style={{ color: "#9aa5b5", fontSize: "0.9em" }}>
            O painel não conseguiu falar com o servidor. Pode ser instabilidade momentânea — tente de novo em instantes.
          </p>
          <button className="btn btn-he" onClick={() => window.location.reload()}>
            <i className="bi bi-arrow-clockwise"></i> Tentar de novo
          </button>
        </div>
      </div>
    );
  }
  if (podeVer(usuario, chave)) return children;

  const rota = primeiraRotaPermitida(usuario);
  // Sem nenhuma seção permitida (lista só com chaves inválidas) — evita loop de redirect
  if (!rota) {
    return (
      <div className="pagina" style={{ textAlign: "center", padding: "3em 1em" }}>
        <p style={{ color: "#9aa5b5" }}>
          Você não tem acesso a nenhuma seção. Fale com o administrador.
        </p>
      </div>
    );
  }
  return <Navigate to={rota} replace />;
}
